import React, { useMemo } from 'react';
import { matchPath, PathMatch, useLocation } from 'react-router-dom';

import { ROUTE_PATHS } from 'shared/consts/routes';

import CexPairHeader from './CexPairHeader';
import DexPairHeader from './DexPairHeader';
import SolPairHeader from './SolPairHeader';

const HeaderPair: React.FC = () => {
  const { pathname } = useLocation();

  const dexPathMatch: PathMatch<'projectId' | 'pairId'> | null = matchPath(
    ROUTE_PATHS.dexPair,
    pathname,
  );
  const solPathMatch: PathMatch<'projectId' | 'pairId'> | null = matchPath(
    ROUTE_PATHS.solPair,
    pathname,
  );
  const cexPathMatch: PathMatch<'projectId' | 'pairId'> | null = matchPath(
    ROUTE_PATHS.cexPair,
    pathname,
  );
  const pairPathMatch: PathMatch<'projectId' | 'pairId'> | null = matchPath(
    ROUTE_PATHS.pair,
    pathname,
  );

  const isDexPair = useMemo(() => !!dexPathMatch, [dexPathMatch]);
  const isSolPair = useMemo(() => !!solPathMatch, [solPathMatch]);
  const isCexPair = useMemo(() => !!cexPathMatch, [cexPathMatch]);
  const isPair = useMemo(() => !!pairPathMatch, [pairPathMatch]);

  const pairId = useMemo(() => {
    if (dexPathMatch) return Number(dexPathMatch.params.pairId ?? 0);
    if (solPathMatch) return Number(solPathMatch.params.pairId ?? 0);
    if (cexPathMatch) return Number(cexPathMatch.params.pairId ?? 0);
    if (pairPathMatch) return Number(pairPathMatch.params.pairId ?? 0);
    return 0;
  }, [dexPathMatch, solPathMatch, cexPathMatch, pairPathMatch]);

  const projectId = useMemo(() => {
    if (dexPathMatch) return Number(dexPathMatch.params.projectId ?? 0);
    if (solPathMatch) return Number(solPathMatch.params.projectId ?? 0);
    if (cexPathMatch) return Number(cexPathMatch.params.projectId ?? 0);
    if (pairPathMatch) return Number(pairPathMatch.params.projectId ?? 0);
    return 0;
  }, [dexPathMatch, solPathMatch, cexPathMatch, pairPathMatch]);

  return (
    <>
      {(isCexPair || (isPair && !isDexPair && !isSolPair)) && (
        <CexPairHeader pairId={pairId} projectId={projectId} />
      )}
      {isDexPair && <DexPairHeader pairId={pairId} projectId={projectId} />}
      {isSolPair && <SolPairHeader pairId={pairId} projectId={projectId} />}
    </>
  );
};

export { HeaderPair };
